import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  makeStyles,
  Theme,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import { Close } from '@carbon/icons-react';
import { setStorageItem, STORAGE_ACTION } from '@utils/storage';
import { colorSet } from '@components/Provider';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { TutorialStepProps } from '../CapaViewTutorial';
import Pin from './pin.png';
import useUserActionLog, {
  CapaActivityType,
  Enum_Action_Button_Enum
} from '@hooks/useUserActionLog';

const TutorialStep5 = ({ handleNextStep }: TutorialStepProps) => {
  const { onInsertUserActionLogOne } = useUserActionLog();
  const { tutorialDialogContainer, tutorialDialogContent } = useStyles();
  const matches = useMediaQuery(useTheme().breakpoints.down('md'));
  const history = useHistory();

  const handleDone = () => {
    setStorageItem(STORAGE_ACTION.NOT_SEEN_AGAIN_CAPA_VIEWER_TUTORIAL, 'true');
    history.push(
      `/chat/${(history.location.state as { rfqId?: string })?.rfqId ?? ''}`
    );
  };

  return (
    <Dialog
      className={tutorialDialogContainer}
      open={true}
      onClose={() => {
        onInsertUserActionLogOne(
          Enum_Action_Button_Enum.Button_Capa_Viewer_Tutorial_BackDrop,
          CapaActivityType.ButtonClick
        );
        handleDone();
      }}
    >
      <DialogContent className={tutorialDialogContent}>
        <Box position={'absolute'} top={18} right={14}>
          <IconButton
            size={'small'}
            onClick={() => {
              onInsertUserActionLogOne(
                Enum_Action_Button_Enum.Button_Capa_Viewer_Tutorial_Close,
                CapaActivityType.ButtonClick
              );
              handleDone();
            }}
          >
            <Close size={24} color={colorSet.gray900}></Close>
          </IconButton>
        </Box>
        <Box marginTop={'26px'}>
          <CustomizedTypography
            variant="body1"
            fontWeight="500"
            color="primary"
          >
            이제 주석 기능을 사용하러 가볼까요?
          </CustomizedTypography>
        </Box>
        <Box marginTop={'4px'}>
          <CustomizedTypography variant="h3" fontWeight="500">
            첫번째 주석을 남겨보세요!
          </CustomizedTypography>
        </Box>
        <Box marginTop={'40px'}>
          <img width={218} src={Pin} alt="pin_img" />
        </Box>
        <Box
          position={'absolute'}
          bottom={0}
          display={'flex'}
          justifyContent={'center'}
          flexDirection={matches ? 'column' : 'row'}
          gridGap={matches ? 10 : 7}
          borderTop={`1px solid ${colorSet.gray400}`}
          width={'100%'}
          padding={'16px'}
        >
          <CustomizedButton
            fullWidth
            variant={'contained'}
            color={'default'}
            size={'large'}
            onClick={() => {
              onInsertUserActionLogOne(
                Enum_Action_Button_Enum.Button_Capa_Viewer_Tutorial_Again,
                CapaActivityType.ButtonClick
              );
              handleNextStep('1');
            }}
          >
            튜토리얼 다시보기
          </CustomizedButton>
          <CustomizedButton
            fullWidth
            variant={'contained'}
            size={'large'}
            onClick={() => {
              onInsertUserActionLogOne(
                Enum_Action_Button_Enum.Button_Capa_Viewer_Tutorial_Close_And_Chat,
                CapaActivityType.ButtonClick
              );
              handleDone();
            }}
          >
            닫고 채팅하기
          </CustomizedButton>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default TutorialStep5;

const useStyles = makeStyles<Theme>((theme) => ({
  tutorialDialogContainer: {
    '& .MuiDialog-paperWidthSm': {
      borderRadius: 16,
      margin: 0
    }
  },
  tutorialDialogContent: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: 413,
    height: 520,
    [theme.breakpoints.down('md')]: {
      width: 343
    }
  }
}));
